import { updates } from '@/mocks/chiguaData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100">
            <i className="ri-flashlight-line text-xl text-primary-600"></i>
          </div>
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
              实时快讯
            </h2>
            <p className="text-sm text-foreground-500 mt-0.5">最新鲜的吃瓜资讯，滚动更新中</p>
          </div>
        </div>

        <div className="relative pl-6 border-l-2 border-primary-200">
          {updates.map((item, idx) => (
            <div
              key={item.id}
              className={`relative pb-8 ${idx === updates.length - 1 ? 'pb-0' : ''}`}
            >
              <div className="absolute -left-[29px] top-1 w-4 h-4 rounded-full border-2 border-primary-500 bg-background-50"></div>
              <div className="flex flex-wrap items-center gap-2 mb-1.5">
                <span className="text-xs text-foreground-400">{item.time}</span>
                <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-secondary-100 text-secondary-800">
                  {item.tag}
                </span>
                {item.hot && (
                  <span className="inline-flex items-center gap-0.5 text-xs text-accent-600 font-medium">
                    <i className="ri-fire-line"></i>
                    热
                  </span>
                )}
              </div>
              <h3 className="text-base md:text-lg font-medium text-foreground-900 leading-relaxed">
                {item.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}